module.exports = __webpack_public_path__ + "media/images/icon_list/circle_close_solid-60054368a1b9c5b4b91950afbc2d6fa7.svg";